import { call, put } from "redux-saga/effects";

import { apiFoco, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";

import { requestErrorHandler } from "utils";
import { CreateWhatsappContactActions } from "store/ducks/whatsappContact";

export function* CreateWhatsappContactRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;
    const { data } = yield call(apiFoco.post, `/whatsapp-contact`, postData);

    yield put(CreateWhatsappContactActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreateWhatsappContactActions.failure(errorMessage));
  }
}
